import { render, staticRenderFns } from "./AllRegionPager.vue?vue&type=template&id=0ec18b94&scoped=true&"
import script from "./AllRegionPager.vue?vue&type=script&lang=js&"
export * from "./AllRegionPager.vue?vue&type=script&lang=js&"
import style0 from "./AllRegionPager.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AllRegionPager.vue?vue&type=style&index=1&id=0ec18b94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec18b94",
  null
  
)

export default component.exports